import React from 'react';

export const Checkbox = ({ id, checked, onCheckedChange }) => {
  return (
    <input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={(e) => onCheckedChange(e.target.checked)}
      className="checkbox"
    />
  );
};
